import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface UserOtherContact {
  id: number
  type: SystemCode
  name: string
}

export function UserOtherContactFromJSON(json: any): UserOtherContact {
  return {
    id: json.id,
    type: exists(json, 'type')
      ? SystemCodeFromJSON(json.type)
      : defaultSystemCode(),
    name: exists(json, 'name') ? json.name : ''
  }
}

export function UserOtherContactToJSON(value: UserOtherContact): any {
  return {
    id: value.id,
    type: value.type.code,
    name: value.name
  }
}
